import { QueryClient } from '@tanstack/react-query'
import { ApiError } from '@/api/errors'

/** App-wide query client. 4xx are not retried (deterministic), 5xx/network are. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.status >= 400 && error.status < 500) {
          return false
        }
        return failureCount < 2
      },
      staleTime: 15_000,
      refetchOnWindowFocus: false,
    },
    mutations: { retry: false },
  },
})
